/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { ref as storageRef, listAll, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

const VisionPage = ({ user, userGoal, onNext, onBack }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const loadImages = async () => {
      try {
        // Load images from Firebase Storage
        const imagesRef = storageRef(storage, `visionBoard/${user.uid}`);
        const imagesList = await listAll(imagesRef);
        
        const imagePromises = imagesList.items.map(async (item) => {
          const url = await getDownloadURL(item);
          return {
            id: item.name,
            url,
            name: item.name
          };
        });

        const loadedImages = await Promise.all(imagePromises);
        setImages(loadedImages);
      } catch (error) {
        console.error('Error loading images:', error);
      } finally {
        setLoading(false);
      }
    };

    loadImages();
  }, [user]);

  // Countdown derived from the goal's real target date.
  const targetMs = userGoal?.targetDate ? new Date(userGoal.targetDate).getTime() : null;
  const daysLeft = targetMs ? Math.max(0, Math.ceil((targetMs - Date.now()) / 86400000)) : null;

  if (loading) {
    return (
      <div className="vision-page-loading">
        <div className="loading-spinner"></div>
        <p>Loading your vision...</p>
      </div>
    );
  }

  return (
    <div className="vision-page">
      <div className="vision-page-header">
        <div className="vision-page-nav-left">
          <button className="vision-back-btn" onClick={onBack}>
            ← Edit Vision
          </button>
          <button className="start-over-btn" onClick={() => onBack('start-over')}>
            🔄 Start Over
          </button>
        </div>
        <div className="vision-page-actions">
          <button className="manifestation-btn" onClick={onNext}>
            Manifestation →
          </button>
        </div>
      </div>

      <div className="vision-board-display">
        {/* Background images */}
        <div className="vision-images-background">
          {images.map((image, index) => (
            <div 
              key={image.id} 
              className={`vision-bg-image vision-bg-image-${index % 8}`}
              style={{ backgroundImage: `url(${image.url})` }}
            />
          ))}
        </div>

        {/* Center content */}
        <div className="vision-center-content">
          <h1 className="vision-goal-title">{userGoal?.title || 'Your Vision'}</h1>
          <p className="vision-goal-description">{userGoal?.description}</p>
          <div className="vision-countdown">
            {daysLeft !== null ? (
              <>
                <span className="vision-days">{daysLeft}</span>
                <span className="vision-days-label">days to manifest</span>
              </>
            ) : (
              <span className="vision-days-label">Set a target date to start your countdown</span>
            )}
          </div>
        </div>

        {/* Overlay for better text readability */}
        <div className="vision-overlay"></div>
      </div>
    </div>
  );
};

export default VisionPage; 